import { useEffect, useState, useRef } from 'react';
import {
  Button,
  Modal,
  Input,
  Checkbox,
  Col,
  Row,
  Select,
  Switch,
  Tooltip,
  message,
  Space,
  Divider,
  Spin,
  Upload,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import './index.less';
import * as api from '@/services/enterprise';
import { SearchOutlined } from '@ant-design/icons';
import { toTree, getApiEnv } from '@/utils/utils';
import Permissions from '../permissions';
import { cloneDeep } from 'lodash-es';
import { useUpload } from '@/hooks';
import { Upload as UploadIcon, Delete, FileDefaultColor } from 'patternx-svg';
import classNames from 'classnames';

const AddComSpace = (props: any) => {
  const {
    handleOK,
    handleCancel,
    tableData,
    comSpaceInfo,
    setComSpaceInfo,
    confirmLoading,
    addTitle,
  } = props;
  const [okStatus, setOKstatus] = useState(false);
  // 获取全量权限列表
  const [permissionsTree, setPermissionTree] = useState<any[]>([]);
  const [permissionsList, setPermissionsList] = useState<any[]>([]);

  // ****生命周期****
  useEffect(() => {
    // setComSpaceInfo({
    //   ...comSpaceInfo,
    //   permissionDTOList: [
    //     { code: 'digit_asset', name: '数字资产库', status: '1', type: '1' },
    //     { code: 'building_lib', name: '封装单体库', status: '1', type: '1' },
    //     { code: 'component_lib', name: '构件库', status: '1', type: '1' },
    //     { code: 'templete_lib', name: '样板文件库', status: '1', type: '1' },
    //     { code: 'material_lib', name: '材质库', status: '1', type: '1' },
    //     { code: 'composition', name: '材料部品库', status: '1', type: '1' },
    //     { code: 'bill', name: '清单库', status: '1', type: '1' },
    //   ],
    // });
    // setCheckedList(['封装单体库', '构件库', '样板文件库', '材质库', '材料部品库', '清单库']);
    getPermissionsList();
  }, []);

  useEffect(() => {
    if (
      comSpaceInfo.companyId !== '' &&
      comSpaceInfo.customize !== '' &&
      comSpaceInfo.name !== '' &&
      comSpaceInfo.ownerName !== '' &&
      comSpaceInfo.ownerPhone !== '' &&
      comSpaceInfo.permissionDTOList !== [] &&
      inputDomainStatus === ''
    ) {
      setOKstatus(true);
    }
  }, [comSpaceInfo]);

  // console.log('props', props);

  // 获取权限列表
  const getPermissionsList = async () => {
    const res = await api.getPermissionsList('1');
    if (res.success) {
      const datas =
        res?.data?.details
          ?.filter(
            (d: any) =>
              d?.name !== '企业管理' &&
              d?.code !== 'sys_manager' &&
              d?.name !== '项目总览' &&
              d?.code !== 'project_manager',
          )
          ?.map((d: any) => {
            return {
              ...d,
              status: '1',
            };
          }) || [];
      // res.data.details.map((item: any, index: any) => {
      //   if (index >= 3) {
      //     optionArray.push({
      //       label: item.name,
      //       value: item.code,
      //       type: item.type,
      //     });
      //     optionNameArray.push(item.name);
      //   }
      // });
      const lists = cloneDeep(datas);
      const newDatas = toTree(lists, {
        id: 'id',
        parentId: 'parentId',
      });
      setPermissionTree(newDatas);
      setPermissionsList(datas);
    }
  };

  // 输入框的内容
  // const [comSpaceInfo, setComSpaceInfo] = useState({
  //     companyId-: '', customize-: '', name-: '', ownerName-: '', ownerPhone-: '', permissionDTOList---: []
  // })
  const { Option } = Select; // 选择器的配置项

  // **** 定义弹出框内的行为函数 ****

  // 选择器-选择所属公司
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [companyList, setCompanyList] = useState<any>([]); // 所属公司列表
  const [selectLoading, setSelectLoading] = useState(false);
  // 点击选择器
  const onSelectClick = async (e: any) => {
    console.log('****点击选择器对象', e.target.name);
    if (e.target.name === 'innerSearch') {
      // setIsSelectOpen(true)
    } else {
      setIsSelectOpen(!isSelectOpen); // 切换选择器展开状态
      setSelectLoading(true);
      console.log('选择器数据', tableData);
      // 缺获取所属公司的接口
      const res = await api.getCompanyList();
      console.log('****点击选择器', res);
      if (res.code == 200 && res.success) {
        setCompanyList(res?.data?.details);
      } else {
        message.error('获取所属公司列表失败');
        setOKstatus(false);
      }
      setSelectLoading(false);
    }
  };
  // 选中选项
  const onSelectCompany = (value: any) => {
    console.log('选择器选中的值', value);
    setComSpaceInfo({
      ...comSpaceInfo,
      companyId: value,
    });
  };

  // 输入企业空间名称
  const [inputComNameStatus, setInputComNameStatus] = useState('');
  const onInputComSpace = (e: any) => {
    console.log('****企业空间名称', e.target.value);
    if (e.target.value === '') {
      setOKstatus(false);
      setInputComNameStatus('error');
    } else {
      setInputComNameStatus('');
    }
    if (e.target.value.length === 50) {
      message.warning('企业空间名最多填写50个字符');
    }
    setComSpaceInfo({
      ...comSpaceInfo,
      name: e.target.value,
    });
  };

  // 输入拥有者手机号
  const [inputPhoneStatus, setInputPhoneStatus] = useState('');
  const onInputOwnerPhone = (e: any) => {
    const phoneReg = /^1[0-9]{10}$/; // 校验用正则
    if (e.target.value === '') {
      setOKstatus(false);
    }
    if (phoneReg.test(e.target.value) === false || e.target.value === '') {
      setInputPhoneStatus('error');
      setOKstatus(false);
    } else {
      console.log('****拥有者手机号', e.target.value);
      setInputPhoneStatus('');
      setComSpaceInfo({
        ...comSpaceInfo,
        ownerPhone: e.target.value,
      });
    }
  };

  // 输入拥有者姓名
  const [inputNameStatus, setInputNameStatus] = useState('');
  const onInputOwnerName = (e: any) => {
    if (e.target.value === '') {
      setOKstatus(false);
      setInputNameStatus('error');
    } else {
      setInputNameStatus('');
    }
    if (e.target.value.length === 50) {
      message.warning('企业拥有者姓名最多填写50个字符');
    }
    console.log('****拥有者姓名', e.target.value);
    setComSpaceInfo({
      ...comSpaceInfo,
      ownerName: e.target.value,
    });
  };

  // todo:后续需要通过接口来增加数据拓展性，暂且写死
  // const plainOptions = ['封装单体库', '构件库', '样板文件库', '材质库', '材料部品库', '清单库'];
  // const permissionDTOList = [
  //   { code: '1', name: '封装单体库', status: '1', type: '1' },
  //   { code: '2', name: '构件库', status: '1', type: '1' },
  //   { code: '3', name: '样板文件库', status: '1', type: '1' },
  //   { code: '4', name: '材质库', status: '1', type: '1' },
  //   { code: '5', name: '材料部品库', status: '1', type: '1' },
  //   { code: '6', name: '清单库', status: '1', type: '1' },
  // ];

  // const defaultCheckedList = [
  //   '封装单体库',
  //   '构件库',
  //   '样板文件库',
  //   '材质库',
  //   '材料部品库',
  //   '清单库',
  // ];
  // const [indeterminate, setIndeterminate] = useState(false); // 全选用
  // const [checkedList, setCheckedList] = useState<any[]>(defaultCheckedList);
  // const [checkAll, setCheckAll] = useState(true);
  // const [isShowOptions, setIsShowOptions] = useState(20);
  // 数字资产库选择
  const onAssetChangeCallback = (params: { isChecked?: boolean; code: string; id: string }) => {
    // console.log('数字资产库选择', e);
    const { isChecked, code, id } = params;
    const status = isChecked ? '1' : '0';
    const lists = cloneDeep(permissionsList);
    lists?.forEach((l) => {
      if (l?.code === code || l?.parentId === id) {
        l.status = status;
      }
    });
    setPermissionsList(lists);
    // 全选
    // if (e.target.checked === false) {
    //   comSpaceInfo.permissionDTOList.map((item: any) => {
    //     console.log('点击数字资产库', item);
    //     item.status = '0';
    //   });
    // } else {
    //   comSpaceInfo.permissionDTOList.map((item: any) => {
    //     console.log('点击数字资产库', item);
    //     item.status = '1';
    //   });
    // }
    // setCheckedList(e.target.checked ? plainOptions : []);
    // setIsShowOptions(e.target.checked ? 20 : 0);
    // setIndeterminate(false);
    // setCheckAll(e.target.checked);
  };
  // 数字资产库，多选框子项选择
  const onOptionChangeCallback = (list: any) => {
    const lists = cloneDeep(permissionsList);
    lists?.forEach((l) => {
      if (l.parentId) {
        if (list?.includes(l.id)) {
          l.status = '1';
        } else {
          l.status = '0';
        }
      }
    });
    setPermissionsList(lists);
    // if (checkedList.length === 1 && list.length === 0) {
    //   message.warning('至少勾选一个应用');
    // } else {
    //   setCheckedList(list);
    //   setIndeterminate(!!list.length && list.length < plainOptions.length);
    //   setCheckAll(list.length === plainOptions.length);
    // }
    // console.log('弹窗内对象checkedList', checkedList);
    // console.log('弹窗内对象list', list);

    // if (list.length !== 0) {
    //   for (let i = 0; i < comSpaceInfo.permissionDTOList.length; i++) {
    //     if (list.some((item: any) => item === comSpaceInfo.permissionDTOList[i].name)) {
    //       console.log('改变了找到了', comSpaceInfo.permissionDTOList);
    //       comSpaceInfo.permissionDTOList[i].status = '1';
    //     } else {
    //       comSpaceInfo.permissionDTOList[i].status = '0';
    //     }
    //     comSpaceInfo.permissionDTOList[0].status = '1';
    //   }
    //   console.log('改变了', list);
    //   // setComSpaceInfo({
    //   //     ...comSpaceInfo
    //   // })
    // } else if (list.length === 0) {
    //   for (let i = 0; i < comSpaceInfo.permissionDTOList.length; i++) {
    //     for (let i = 0; i < comSpaceInfo.permissionDTOList.length; i++) {
    //       if (checkedList.some((item: any) => item === comSpaceInfo.permissionDTOList[i].name)) {
    //         console.log('改变了找到了', comSpaceInfo.permissionDTOList);
    //         comSpaceInfo.permissionDTOList[i].status = '1';
    //       } else {
    //         comSpaceInfo.permissionDTOList[i].status = '0';
    //       }
    //       comSpaceInfo.permissionDTOList[0].status = '1';
    //     }
    //   }
    //   // setComSpaceInfo({
    //   //     ...comSpaceInfo
    //   //     // permissionDTOList: checkedList
    //   // })
    // }
  };

  // 切换是否定制化
  const onCustomiseChange = (value: any) => {
    console.log('定制化', value);
    setComSpaceInfo({
      ...comSpaceInfo,
      customize: value,
    });
  };

  // const [innerSelectLoading, setInnerSelectLoading] = useState(false)
  const inputInnerSearch = useRef('');
  const onInnerInput = async (e: any) => {
    inputInnerSearch.current = e.target.value;
    if (e.target.value === '') {
      // setInnerSelectLoading(true)
      const res = await api.getCompanyList();
      console.log('inputInnerSearch', res);
      if (res.code === 200 && res.success) {
        setCompanyList(res?.data?.details);
        // setInnerSelectLoading(false)
      } else {
        message.error('获取公司名称列表失败');
        // setInnerSelectLoading(false)
      }
    }
  };

  const searchComSelect = () => {
    const value = inputInnerSearch.current;
    const searchList: any = [];
    // setInnerSelectLoading(true)
    if (value !== '') {
      companyList.map((item: any) => {
        console.log('companyList', value, item);
        if (item.name.indexOf(value) !== -1) {
          searchList.push(item);
        }
      });
      setCompanyList(searchList);
      console.log('inputInnerSearch', searchList);
    }
    // setInnerSelectLoading(false)
  };

  const { uploadRequest } = useUpload();

  const getBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const uploadFile = (files: any, callback: Function) => {
    uploadRequest({
      url: '/storage/v1/objects/upload/presigned',
      fileStream: files,
      appName: 'boss',
      policy: 1,
      srcShortName: files.name,
      srcFileSuffix: files?.name?.split('.')?.pop() ?? 'png',
      srcFullPath: '/test/',
      srcFileSize: files?.size,
      onPreload: () => {},
      onProgress: () => {},
      onSuccess: async (res: any) => {
        const { file, storage } = res ?? {};
        file.fileUrl = await getBase64(file);
        file.fileStorageId = storage?.storageFileId;
        callback?.(file);
        // cloudModel.putComplete(storage?.storageFileId);
      },
      onError: async (err: any) => {
        const { exists, file, storage } = err ?? {};
        if (exists) {
          file.fileUrl = await getBase64(file);
          file.fileStorageId = storage?.storageFileId;
          callback?.(file);
          // cloudModel.putComplete(storage?.storageFileId);
        }
      },
    });
  };

  const logoProp = {
    showUploadList: false,
    accept: '.png',
    beforeUpload(f: any) {
      if (comSpaceInfo?.logo?.length > 1) {
        message.info('最多上传1个文件');
        return false;
      }

      const isLt1M = f?.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        message.info('大小超限，请根据要求上传');
        return false;
      }
      uploadFile(f, (file: any) => {
        setComSpaceInfo({
          ...comSpaceInfo,
          logo: [file],
        });
      });
    },
  };

  const icoProp = {
    showUploadList: false,
    accept: '.ico',
    beforeUpload(f: any) {
      if (comSpaceInfo?.ico?.length > 1) {
        message.info('最多上传1个文件');
        return false;
      }
      uploadFile(f, (file: any) => {
        setComSpaceInfo({
          ...comSpaceInfo,
          ico: [file],
        });
      });
    },
  };

  const backgroundProp = {
    showUploadList: false,
    accept: '.png,.jpg,.jpeg',
    beforeUpload(f: any) {
      if (comSpaceInfo?.background?.length > 1) {
        message.info('最多上传1个文件');
        return false;
      }
      uploadFile(f, (file: any) => {
        setComSpaceInfo({
          ...comSpaceInfo,
          background: [file],
        });
      });
    },
  };

  // 输入定制域名
  const [inputDomainStatus, setInputDomainStatus] = useState('');
  const [inputDomainErrorText, setInputDomainErrorText] = useState('');

  const checkDomain = (val: string, isShowTip: boolean) => {
    if (val && val.length < 2) {
      if (isShowTip) {
        setInputDomainStatus('error');
        setInputDomainErrorText('最少输入2个字符');
      }
      setOKstatus(false);
    } else if (val?.length >= 2 && !/^[a-zA-Z0-9]{2,20}$/.test(val)) {
      if (isShowTip) {
        setInputDomainStatus('error');
        setInputDomainErrorText('格式错误，仅支持小写字母、数字、横线、下划线和点');
      }
      setOKstatus(false);
    } else {
      setInputDomainStatus('');
      setInputDomainErrorText('');
    }
  };

  const onInputDomain = (e: any) => {
    const val = e.target.value;
    checkDomain(val, true);
    setComSpaceInfo({
      ...comSpaceInfo,
      domainIdentify: val,
    });
  };

  return (
    <>
      <Modal
        title={addTitle}
        visible={true}
        width={800}
        keyboard={true}
        onCancel={handleCancel}
        className="addComSpaceModal"
        footer={
          okStatus
            ? [
                <Button onClick={handleCancel}>取消</Button>,
                <Button
                  type="primary"
                  onClick={() => handleOK(permissionsList)}
                  loading={confirmLoading}
                >
                  确定
                </Button>,
              ]
            : [
                <Button onClick={handleCancel}>取消</Button>,
                <Button type="primary" onClick={() => handleOK(permissionsList)} disabled>
                  确定
                </Button>,
              ]
        }
      >
        <div className="mention">以下信息将用于用户侧信息展示，请谨慎填写</div>
        <div className="comspaceModalContent">
          <Row justify="start" style={{ marginTop: 55 }}>
            <Col span={11}>
              <div className="inputCompany inputLabel">
                {' '}
                <span className="lableRequired">*</span>所属公司{' '}
              </div>
              <div className="modalInput">
                <Select
                  style={{ width: '100%' }}
                  onChange={onSelectCompany}
                  placeholder="选择所属公司"
                  open={isSelectOpen}
                  onClick={onSelectClick}
                  loading={selectLoading}
                  defaultActiveFirstOption={true}
                  dropdownRender={(menu) => (
                    <>
                      <Space style={{ padding: '4px 8px', width: '100%' }}>
                        <Input
                          // size={'small'}
                          style={{ width: '100%' }}
                          prefix={<SearchOutlined />}
                          placeholder={'搜索公司名称'}
                          name="innerSearch"
                          onChange={onInnerInput}
                          onPressEnter={() => searchComSelect()}
                        />
                      </Space>
                      <Divider style={{ margin: '8px 0' }} />
                      {menu}
                    </>
                  )}
                >
                  {/* <Spin spinning={innerSelectLoading}> */}
                  {companyList.map((item: any) => (
                    <Option value={item.id}>{item.name}</Option>
                  ))}
                  {/* </Spin> */}
                </Select>
              </div>
            </Col>
            <Col span={1}></Col>
            <Col span={11}>
              <div className="inputComSpace inputLabel">
                <span className="lableRequired">*</span>企业空间名称{' '}
              </div>
              <div className="modalInput">
                <Input
                  placeholder="输入企业空间名称"
                  onChange={onInputComSpace}
                  status={inputComNameStatus === 'error' ? inputComNameStatus : undefined}
                  maxLength={50}
                />
                {inputComNameStatus === 'error' ? (
                  <div className="inputMention">请输入企业空间名称</div>
                ) : (
                  <></>
                )}
              </div>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row justify="start">
            <Col span={11}>
              <div className="inputOwnerPhone inputLabel">
                <span className="lableRequired">*</span>企业拥有者手机号{' '}
              </div>
              <div className="modalInput">
                <Input
                  placeholder="输入拥有者手机号"
                  onChange={onInputOwnerPhone}
                  status={inputPhoneStatus === 'error' ? inputPhoneStatus : undefined}
                  maxLength={11}
                />
                {inputPhoneStatus === 'error' ? (
                  <div className="inputMention">手机号格式错误</div>
                ) : (
                  <></>
                )}
              </div>
            </Col>
            <Col span={1}></Col>
            <Col span={11}>
              <div className="inputOwnerName inputLabel">
                <span className="lableRequired">*</span>企业拥有者姓名{' '}
              </div>
              <div className="modalInput">
                <Input
                  placeholder="输入拥有者姓名"
                  onChange={onInputOwnerName}
                  status={inputNameStatus === 'error' ? inputNameStatus : undefined}
                  maxLength={50}
                />
                {inputNameStatus === 'error' ? (
                  <div className="inputMention">请输入拥有者姓名</div>
                ) : (
                  <></>
                )}
              </div>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row justify="start">
            <Col span={11}>
              <div className="inputOwnerPhone inputLabel">
                企业LOGO
                <span className="subLabel">（大小不超过1M，格式PNG，高度固定为60px）</span>
              </div>
              <div className="modalInput">
                <Upload {...logoProp} key="uploadLogo">
                  <div
                    className={classNames('uploadBtn', { disable: comSpaceInfo?.logo?.length > 0 })}
                  >
                    <UploadIcon size={20} className="uploadIcon" />
                    点击上传
                  </div>
                </Upload>
                {comSpaceInfo?.logo?.map((l: any) => (
                  <div className="imgWrap" key={l?.fileStorageId}>
                    <div className="imgInfo">
                      <div className="imgBox">
                        {l?.fileUrl ? (
                          <img src={l?.fileUrl} alt="logo" className="img" />
                        ) : (
                          <FileDefaultColor size="36" />
                        )}
                      </div>
                      <div className="imgName">{l?.name}</div>
                    </div>
                    <Delete
                      size={20}
                      className="imgDeleteIcon"
                      onClick={() =>
                        setComSpaceInfo({
                          ...comSpaceInfo,
                          logo: [],
                        })
                      }
                    />
                  </div>
                ))}
              </div>
            </Col>
            <Col span={1}></Col>
            <Col span={11}>
              <div className="inputOwnerName inputLabel">
                ico图标
                <span className="subLabel">（浏览器页签展示，大小32x32或64x64）</span>
              </div>
              <div className="modalInput">
                <Upload {...icoProp} key="uploadLogo">
                  <div
                    className={classNames('uploadBtn', { disable: comSpaceInfo?.ico?.length > 0 })}
                  >
                    <UploadIcon size={20} className="uploadIcon" />
                    点击上传
                  </div>
                </Upload>
                {comSpaceInfo?.ico?.map((co: any) => (
                  <div className="imgWrap" key={co?.fileStorageId}>
                    <div className="imgInfo">
                      <div className="imgBox">
                        {co?.fileUrl ? (
                          <img src={co?.fileUrl} alt="ico" className="img" />
                        ) : (
                          <FileDefaultColor size="36" />
                        )}
                      </div>
                      <div className="imgName">{co?.name}</div>
                    </div>
                    <Delete
                      size={20}
                      className="imgDeleteIcon"
                      onClick={() =>
                        setComSpaceInfo({
                          ...comSpaceInfo,
                          ico: [],
                        })
                      }
                    />
                  </div>
                ))}
              </div>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row justify="start">
            <Col span={11}>
              <div className="inputOwnerPhone inputLabel">
                登录页背景图
                <span className="subLabel">（格式PNG/JPG/JPEG，尺寸1920x1080）</span>
              </div>
              <div className="modalInput">
                <Upload {...backgroundProp} key="uploadLogo">
                  <div
                    className={classNames('uploadBtn', {
                      disable: comSpaceInfo?.background?.length > 0,
                    })}
                  >
                    <UploadIcon size={20} className="uploadIcon" />
                    点击上传
                  </div>
                </Upload>
                {comSpaceInfo?.background?.map((back: any) => (
                  <div className="imgWrap" key={back?.fileStorageId}>
                    <div className="imgInfo">
                      <div className="imgBox">
                        {back?.fileUrl ? (
                          <img src={back?.fileUrl} alt="" className="img" />
                        ) : (
                          <FileDefaultColor size="36" />
                        )}
                      </div>
                      <div className="imgName">{back?.name}</div>
                    </div>
                    <Delete
                      size={20}
                      className="imgDeleteIcon"
                      onClick={() =>
                        setComSpaceInfo({
                          ...comSpaceInfo,
                          background: [],
                        })
                      }
                    />
                  </div>
                ))}
              </div>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row justify="start">
            <Col span={23}>
              <div className="inputOwnerPhone inputLabel">企业域名设置</div>
              <div className="modalInput">
                <Input
                  addonBefore="https://"
                  addonAfter={`-vip${getApiEnv()}.patternx.com`}
                  placeholder="输入大小写字母、数字，2-20个字符"
                  onChange={onInputDomain}
                  status={inputDomainStatus === 'error' ? inputDomainStatus : undefined}
                  maxLength={20}
                />
                {inputDomainStatus === 'error' ? (
                  <div className="inputMention" style={{ marginLeft: '70px' }}>
                    {inputDomainErrorText}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </Col>
          </Row>
          <div className="inputLabel"> 企业级应用 </div>
          <div className="comCheckBox">
            <Checkbox checked={true} disabled={true}>
              企业管理
            </Checkbox>
          </div>
          <div className="comCheckBox">
            <Checkbox checked={true} disabled={true}>
              项目总览
            </Checkbox>
          </div>
          {permissionsTree?.map((p) => (
            <Permissions
              key={p.id}
              datas={p}
              checkCallback1={onAssetChangeCallback}
              checkCallback2={onOptionChangeCallback}
            ></Permissions>
          ))}
          <Row>
            <div className="customization">
              定制化 <span> </span>
              <Tooltip
                placement="top"
                title={'开启后企业可在“天云筑”平台中“企业管理”下的企业设置中进行定制化配置'}
                color="#1D1D29 80%"
              >
                <QuestionCircleOutlined style={{ color: '#5F6173' }} color="#5F6173" />
              </Tooltip>
            </div>
          </Row>
          <Row>
            <div>
              <Switch onChange={onCustomiseChange} />
            </div>
          </Row>
        </div>
      </Modal>
    </>
  );
};
export default AddComSpace;
